export class Serie {
    name: string;
    value: number;
    isForecasted: boolean;
    isInactive: boolean;

    constructor(name: string, value: number, isForecasted: boolean = false, isInactive: boolean = false) {
        this.name = name;
        this.value = value;
        this.isForecasted = isForecasted;
        this.isInactive = isInactive;
    }
}
